import {get} from "../../../Utils/Crypto";

let  plugins, luna, token, guest, report;

let SANDBOX_MODE = window.location.href.includes('corporate-sandbox-old.dice.tech');

plugins = "https://plugins.eka.io/";
guest = "https://inventories.eka.io/";
report = "https://reports.eka.io/"
luna = "support";
token = () => get("refresh_token");

let DEV_ENVIRONMENT = false ;
let DEV_MODE = false;
let UAT_MODE = false;
let AUTHURL=  `https://auth.dice.tech/auth/admin`;
let HARDCODEURL = `https://heimdall.eka.io/admin/`;
let TABLEULR = `.tables.eka.io`
let ANALYTICS_API = 'https://analytics.eka.io/admin'
let AUDIT_LOG = 'https://audits.eka.io/admin'
// Production
if(window.location.href.includes('localhosts') || window.location.href.includes('enterprise-dev.dice.tech') || window.location.href.includes('dev-enterprise-dice-tech') || window.location.href.includes('enterprise.dev.eka.io') || window.location.href.includes('admin-dev.eka.io') || DEV_ENVIRONMENT) {
	DEV_MODE = true;
	HARDCODEURL = `https://api.dev.eka.io/admin/`;
	plugins=`https://integration.dev.eka.io/`;
	TABLEULR=`.tables.dev.eka.io`
	AUDIT_LOG = `https://api.dev.eka.io/admin`;
	guest = "https://properties.dev.eka.io/";
	report="https://reports.dev.eka.io/"
}

if(window.location.href.includes('sandbox-dice.netlify.app')){
	UAT_MODE = true;
	AUDIT_LOG = `https://audits.eka.io/admin`;
}

//  SandBox Mode
if(window.location.href.includes('sandbox-uat-v2')|| window.location.href.includes('dice-uat.eka.io')){
	DEV_MODE = true
	ANALYTICS_API = `https://uat-v2.eka.io/admin`
}

// Analytic DEV
if(window.location.href.includes('dev-enterprise-dice-tech') || window.location.href.includes('enterprise-dev.dice.tech') || window.location.href.includes('enterprise.dev.eka.io') || window.location.href.includes('admin-dev.eka.io') || DEV_ENVIRONMENT){
     ANALYTICS_API = `https://api.dev.eka.io/admin`
}
// Analytic UAT
if(window.location.href.includes('sandbox-dice') || window.location.href.includes('enterprise-sandbox.dice.tech')){
	  UAT_MODE = true;
      ANALYTICS_API = `https://dice-uat.eka.io/admin`
	  HARDCODEURL = `https://dice-uat.eka.io/admin`;
}


if(SANDBOX_MODE) {
	HARDCODEURL = `https://api-uat-sandbox.eka.io/admin/`;
	plugins=`https://uat-plugins.eka.io/`;
	TABLEULR=`.tables-uat.eka.io`;
	report="https://uat-reports.eka.io/"
	ANALYTICS_API = `https://api-uat-sandbox.eka.io/admin`;
}

export {
	  plugins, luna, token, guest,  report,HARDCODEURL,AUTHURL,DEV_ENVIRONMENT,TABLEULR,DEV_MODE,ANALYTICS_API,AUDIT_LOG,UAT_MODE,SANDBOX_MODE
}
